import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  frequencyFieldsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  timeUnitsSelect: {
    width: 120,
    marginTop: [0, '!important']
  },
  frequencyField: {
    maxWidth: [60, '!important'],
    '&.inlineField input': {
      padding: [10, '!important']
    }
  }
})

export default useStyles
